window.editorDocumentType = EDITOR_DOC_TYPE;

window.retrieveContainer = function(){
  return Pegasus.EditorProxy.create();
};

window.retrieveAssetHost = function(){
  return window.location.protocol + '//' + window.location.host;
};

window.retrieveContent = function(){
  return parentContainer.get('content.message');
};

window.retrieveMergeFields = function(){
  return parentContainer.get('mergeFields');
};

Pegasus.setup({
  //template: <%= raw(@template.to_json) %>,
  //handoffHost: <%= raw(@handoff_host.to_json) %>
});

Pegasus.advanceReadiness();

